import Dialog from "../../components/Dialog";
import AssignedAdventureForm from "./AssignedAdventureForm";
import { useState } from "react";

export default function AssignedAdventureDialog({ visible, hide, item, preloaded, ...props }) {
	const [loading, setLoading] = useState(false);

	return (
		<Dialog
			title={item ? "Change Assigned Adventure" : "Assign Adventure"}
			visible={visible} onCancel={hide} closable={!loading}
		>
			<AssignedAdventureForm
				{...props} id={item?.id}
				item={preloaded ? item : undefined}
				submitting={loading}
				setSubmitting={l => setLoading(l)}
				onCancel={hide}
			/>
		</Dialog>
	)
}
